import { GRID_COLS, GRID_ROWS, TILE_SIZE, CELL } from './config';
import { HALF } from './gameConstants';

export function walkable(grid, c, r) {
  if (r < 0 || r >= GRID_ROWS || c < 0 || c >= GRID_COLS) return false;
  const v = grid[r][c];
  return v !== CELL.WALL && v !== CELL.HUB;
}

export function walkableWrap(grid, c, r) {
  if (c < 0 || c >= GRID_COLS) {
    c = ((c % GRID_COLS) + GRID_COLS) % GRID_COLS;
  }
  if (r < 0 || r >= GRID_ROWS) {
    r = ((r % GRID_ROWS) + GRID_ROWS) % GRID_ROWS;
  }
  const v = grid[r][c];
  return v !== CELL.WALL && v !== CELL.HUB;
}

export function wrapCoords(c, r) {
  return {
    col: ((c % GRID_COLS) + GRID_COLS) % GRID_COLS,
    row: ((r % GRID_ROWS) + GRID_ROWS) % GRID_ROWS,
  };
}

export function isFloorLike(grid, c, r) {
  if (c < 0 || c >= GRID_COLS || r < 0 || r >= GRID_ROWS) return false;
  return grid[r][c] !== CELL.WALL;
}

export function countNeighbors(grid, c, r) {
  let n = 0;
  if (walkable(grid, c, r - 1)) n++;
  if (walkable(grid, c, r + 1)) n++;
  if (walkable(grid, c - 1, r)) n++;
  if (walkable(grid, c + 1, r)) n++;
  return n;
}
